import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import DefaultFallback from '@/_boundaries/DefaultFallback/DefaultFallback';
import LoginPage from '@/Login/LoginPage';
import Logo from '@/_components/Logo/Logo';
import PageLoadingSpinner from '@/_components/PageLoadingSpinner/PageLoadingSpinner';
import SessionInitializer from '@/Login/SessionInitializer';

// Lazy load major components to improve performance.
// These will be loaded only when their corresponding routes are accessed.
const WelcomePage = React.lazy(() => import('@/Welcome/WelcomePage'));
const DebriefPage = React.lazy(() => import('@/Debrief/DebriefPage'));
// Currently trying to debug why zh-CN locale is triggering a Sentry TypeError on resolving lazy loaded OverviewPage
const OverviewPage = React.lazy(async () => {
  const module = await import('@/Overview/OverviewPage');
  if (module === undefined) {
    throw new Error('OverviewPage dynamic import resolved to undefined');
  }
  if (module.default === undefined) {
    throw new Error('OverviewPage dynamic import resolved without a default export');
  }
  return module;
});
const QualityControlPage = React.lazy(() => import('@/QualityControl/QualityControlPage'));
const SurveyPage = React.lazy(() => import('@/Survey/SurveyPage'));

import '@/styles/bootstrap.scss';

const App = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary FallbackComponent={DefaultFallback}>
        <SessionInitializer />
        <React.Suspense fallback={<PageLoadingSpinner label="Loading page content" />}>
          <Logo />
          <Routes>
            <Route path='/' element={<LoginPage />} />
            <Route path='login' element={<LoginPage />} />
            <Route path='login/:login_code_value' element={<LoginPage />} />
            <Route path='welcome' element={<WelcomePage />} />
            <Route path='overview' element={<OverviewPage />} />
            <Route path='surveys/:slug' element={<SurveyPage />} />
            <Route path='quality-control' element={<QualityControlPage />}/>
            <Route path='debrief' element={<DebriefPage />}/>
          </Routes>
        </React.Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;